import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { business_en } from "../../shared/translations/business_en";
import { business_sv } from "../../shared/translations/business_sv";
import { en } from "../../shared/translations/en";
import { sv } from "../../shared/translations/sv";

export function initTranslations() {
  i18n.use(initReactI18next).init({
    compatibilityJSON: "v3",
    resources: {
      en: {
        common: en,
        business: business_en,
      },
      sv: {
        common: sv,
        business: business_sv,
      },
    },
    ns: ["common", "business"],
    defaultNS: "common",
    fallbackNS: "common",
    lng: __DEV__ ? "sv" : "en",
    fallbackLng: "en",

    supportedLngs: ["en", "sv"],
    interpolation: {
      escapeValue: false,
    },
  });
}
